import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TreeModule } from '@ali-hm/angular-tree-component';
/*
import {AppAbility} from '../login/appAbility';
import {PureAbility} from '@casl/ability';
 */
/* Footer (wird nicht genutzt aber Kiosk-Frontend hat einen) */
// *******************************************************************************
// Libs
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { I18nPipeModule } from '@pipes';

import { SidenavModule } from '../../vendor/libs/sidenav/sidenav.module';
import { SharedModule } from '../mwsp/shared/shared.module';
import { StatisticModule } from '../mwsp/statistic/statistic.module';
import { SupplierModule } from '../mwsp/supplier/supplier.module';
// *******************************************************************************
// Services
import { LayoutService } from './layout.service';
/* Sidebar */
import { OcFooterComponent } from './oc-footer/oc-footer.component';
/* Basis-Template */
import { OcLayoutBlankComponent } from './oc-layout-blank/oc-layout-blank.component';
// *******************************************************************************
// Layouts
import { OCLayout } from './oc-layout/oc-layout.component';
/* Genutzt unter anderem für Print */
// *******************************************************************************
// Components
import { OcNavbarComponent } from './oc-navbar/oc-navbar.component';
/* Navbar bzw. Header */
import { OcSidenavComponent } from './oc-sidenav/oc-sidenav.component';

// *******************************************************************************
//

@NgModule({
    imports: [
        CommonModule, //
        RouterModule,
        NgbModule,
        SidenavModule,
        TreeModule,
        SupplierModule,
        StatisticModule,
        SharedModule,
        ClipboardModule,
        I18nPipeModule,
    ],
    declarations: [
        OCLayout, //
        OcLayoutBlankComponent,
        OcNavbarComponent,
        OcSidenavComponent,
        OcFooterComponent,
    ],
    providers: [LayoutService],
})
export class LayoutModule {}
